<script>
import broker from '../../utils/broker';
import Header from '../../components/header-top-fix-green';
import BreadCrumb from '../../components/bread-crumb-green';
import JurusanGrid from '../../components/jurusan-grid';
import Footer from '../../components/footer-green';
import OffCanvasMobileMenu from '../../components/off-canvas-mobile-menu-green';

export default {
  props: ['dataMeta'],
  components: {
    Header,
    BreadCrumb,
    JurusanGrid,
    Footer,
    OffCanvasMobileMenu,
  },
  data() {
    return {
      majors: [],
      items: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Jurusan',
          active: true,
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: `${this.dataMeta.name} - Jurusan`,
      htmlAttrs: {
        lang: 'en',
        amp: true,
      },
    };
  },
  mounted() {
    broker.fetch
      .get(`/webschool/content?types[]=majors&status=published`)
      .then((res) => {
        const data = res.data.data;
        this.majors = data.filter((o) => o.type.name === 'majors');
      });
  },
};
</script>

<template>
  <div class="main-container">
    <Header :meta="dataMeta" />

    <!-- <BreadCrumb  :items="items" title="Jurusan" /> -->

    <!-- Projects section start -->
    <div class="page-wrapper section-space--inner--80">
      <div class="project-section">
        <div class="container">
          <div class="row section-space--bottom--40">
            <div class="col-sm-12 text-center">
              <h3 class="text-color-green font-size-24">Jurusan</h3>
              <h2>Jurusan {{ this.dataMeta.name }}</h2>
              <p>
                Beberapa macam jurusan yang ada pada {{ this.dataMeta.name }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="project-item-wrapper">
                <div class="row justify-content-center">
                  <div
                    class="col-lg-4 col-sm-6 col-12 section-space--bottom--30"
                    v-for="major in majors"
                    :key="major.id"
                  >
                    <JurusanGrid :data="major" :meta="dataMeta" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer bgFooter="old-blue-bg" :meta="dataMeta" />

    <OffCanvasMobileMenu :meta="dataMeta" />

    <!-- back to top start -->
    <back-to-top class="scroll-top-green" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>
